import { useEffect, useState, useCallback } from 'react';

// 안드로이드 크롬(및 크로미움 계열)이 PWA 설치 가능 조건을 만족하면 쏘는
// beforeinstallprompt 이벤트를 잡아뒀다가, 로고 클릭 등 원하는 시점에
// 우리가 직접 띄울 수 있게 해주는 훅이다.
//
// **아이폰 사파리는 이 이벤트 자체를 지원하지 않는다** - iOS는 사용자가
// 공유 버튼 → "홈 화면에 추가"를 직접 눌러야 하고, 코드로 대신 띄워줄
// 방법이 없다. 그래서 canInstall이 계속 false로 남고, 로고를 눌러도
// 아무 일도 안 일어난다(에러 대신 조용히 무시 - 애초에 없는 기능을
// 억지로 안내하면 더 헷갈린다).
//
// 이미 설치된 상태에서도 브라우저가 이벤트를 안 쏘므로 canInstall이
// false로 유지된다 - "이미 깔려 있다"는 걸 우리가 따로 감지할 필요 없이
// 자연스럽게 처리된다.
export default function useInstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);

  useEffect(() => {
    const handler = (event) => {
      // 브라우저 기본 설치 배너(하단 미니 인포바)를 막고, 이벤트를 저장해
      // 뒀다가 우리가 원하는 타이밍(로고 클릭)에 직접 띄운다.
      event.preventDefault();
      setDeferredPrompt(event);
    };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const promptInstall = useCallback(async () => {
    if (!deferredPrompt) {
      return;
    }
    deferredPrompt.prompt();
    // 사용자가 설치/취소 중 뭘 골랐든, 이벤트는 한 번만 쓸 수 있어서
    // 다시 초기화한다(다음 beforeinstallprompt를 기다림).
    await deferredPrompt.userChoice;
    setDeferredPrompt(null);
  }, [deferredPrompt]);

  return { canInstall: deferredPrompt != null, promptInstall };
}
